import { Divider, Form } from 'antd';
import RadioCards from 'components/RadioCards/RadioCards';
import { Banner } from 'components/ui/Banner';
import { ORDER_TITLE_MAP } from '../../../familyApplicationConstants';
import { getApplicantFirstName } from 'containers/Family/AddApplication2/utils';
import { useMemo } from 'react';

export const OrderTitleQuestions = ({ applicant, orderTitles, isCompletedBySponsor, militaryComponent }) => {
  const filteredOrderTitles = useMemo(() => {
    if (!orderTitles) return [];
    if (!militaryComponent) return orderTitles;

    const allowedIds = Object.values(ORDER_TITLE_MAP)
      .filter((entry) => entry.componentIds.includes(militaryComponent))
      .map((entry) => entry.id);

    return orderTitles.filter((option) => allowedIds.includes(option.id));
  }, [orderTitles, militaryComponent]);

  return (
    <>
      <Divider dashed className="my-12" />

      <Banner
        variant="inline"
        question={
          isCompletedBySponsor
            ? 'What type of orders are you on?'
            : `What type of orders is ${getApplicantFirstName(applicant)} on?`
        }
        className="mb-8"
      />

      <Form.Item
        name="orderTitle"
        rules={[
          {
            required: true,
            message: 'Please select an order type',
          },
        ]}
        className="mb-0"
      >
        <RadioCards
          options={filteredOrderTitles?.map((_option) => {
            let label = _option.name;

            if (isCompletedBySponsor) {
              const orderTitleEntry = Object.values(ORDER_TITLE_MAP).find((e) => e.id === _option.id);
              if (orderTitleEntry) label = orderTitleEntry.label;
            }

            return {
              label: label,
              description: isCompletedBySponsor ? undefined : _option.description,
              value: _option.id,
            };
          })}
        />
      </Form.Item>
    </>
  );
};
